import React from 'react';
import cn from 'classnames';
import styles from './IndicatorBadge.module.scss';

const IndicatorBadge = ({
  bgColor = 'transparent',
  className,
  withBorder = false,
  isSquare = false,
  isBorder = false,
  ...props
}) => {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        ...(isBorder
          ? { backgroundColor: 'transparent', border: `2px solid ${bgColor}` }
          : { backgroundColor: bgColor }),
      }}
      className={cn(styles.root, className, {
        [styles.border]: withBorder,
        [styles.circle]: !isSquare,
        [styles.square]: isSquare,
      })}
    />
  );
};

export default IndicatorBadge;
